import { useMemo } from "react";

import { UserInfo } from "@/api/rest/models/account";
import { Building } from "@/api/rest/models/building";

export const useIsBuildingOwner = (user: UserInfo | null, building: Building | undefined) => {
  return useMemo(() => {
    if (!building || !user) {
      return false;
    }
    const managedBuildings = user.accounts.flatMap((acc) => acc.managedBuildings);
    return managedBuildings.some((managedBuilding) => managedBuilding.buildingId === building.buildingId);
  }, [building, user]);
};
